import { RouteObject } from 'react-router-dom'
import LineMessageLogPage from './pages/LineMessageLogPage'
import LineMessageLogDetailPage from './pages/LineMessageLogDetailPage'

export const lineMessageLogRoutes: RouteObject[] = [
	{
		path: 'line-message-log',
		element: <LineMessageLogPage />,
	},
	{
		path: 'line-message-log/:id',
		element: <LineMessageLogDetailPage />,
	},
]
